<template>
  <div class="h-full flex flex-col overflow-hidden">

    <div class="px-2 py-1.5 text-xs uppercase tracking-widest text-gray-500 border-b border-gray-700 shrink-0">
      Repositories
    </div>

    <!-- Loading skeleton -->
    <div v-if="repoStore.loading" class="flex-1 flex items-center justify-center text-gray-500 text-xs gap-1.5">
      <span class="animate-pulse">⋯</span>
      <span>Loading…</span>
    </div>

    <!-- Error state -->
    <div v-else-if="repoStore.error" class="flex-1 p-3 flex flex-col gap-2">
      <p class="text-red-400 text-xs">{{ repoStore.error }}</p>
      <button
        class="text-xs text-gray-400 hover:text-white underline self-start"
        @click="repoStore.fetchRepositories()"
      >
        Retry
      </button>
    </div>

    <!-- Empty state -->
    <div
      v-else-if="repoStore.repositories.length === 0"
      class="flex-1 flex items-center justify-center text-gray-600 text-xs text-center px-4"
    >
      No repositories configured.<br>
      Check <code class="text-gray-500">IDE_ALLOWED_PATHS</code>.
    </div>

    <!-- Repository list -->
    <ul v-else class="flex-1 overflow-y-auto py-1">
      <li
        v-for="repo in repoStore.repositories"
        :key="repo.id"
        class="flex items-center gap-2 px-3 py-1.5 cursor-pointer hover:bg-gray-700 transition-colors text-sm"
        :class="{ 'bg-gray-600/60': repo.id === repoStore.activeRepo?.id }"
        @click="repoStore.setActiveRepo(repo)"
      >
        <!-- Git vs plain directory icon -->
        <span class="shrink-0 text-base">{{ repo.isGit ? '🔀' : '📁' }}</span>

        <div class="flex-1 min-w-0">
          <div
            class="truncate"
            :class="repo.id === repoStore.activeRepo?.id ? 'text-white' : 'text-gray-200'"
          >
            {{ repo.name }}
          </div>
          <div v-if="repo.currentBranch" class="text-xs text-blue-400 truncate mt-0.5">
            {{ repo.currentBranch }}
          </div>
        </div>

        <span v-if="repo.isGit" class="text-[10px] text-gray-500 shrink-0">git</span>
      </li>
    </ul>

  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRepoStore } from './repoStore'

const repoStore = useRepoStore()

onMounted(() => repoStore.fetchRepositories())
</script>
